export const setAdding = ({ setIsAdding }) => () => setIsAdding(true);

export const setNotAdding = ({ setIsAdding }) => () => setIsAdding(false);
